/**
 * RESPONSIBILITY: one card — a picture, a name, a line, and somewhere it goes.
 *
 * The single most repeated shape on this site: ministries, special events, resources,
 * and the "large cards with pictures & tag lines" the requirements doc asks for in three
 * separate places. One row type rather than four near-identical ones, because the
 * difference between them is which list they sit in, not what they hold.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Paragraph, Img, Link } from '@framework/core/decorators';
import { LINK_HINT } from '../../hints';

@Row()
export class Card {
  @Text({ label: 'Title', maxLength: 120 })
  title!: string;

  @Paragraph({
    label: 'Description', maxLength: 600, rows: 2,
    description: 'The line under the title on the card.',
  })
  blurb!: string;

  @Img({
    label: 'Image', folder: 'cards', maxSizeMb: 12, size: '800 × 600',
    description: 'The picture on the card.',
  })
  image!: ImageValue;

  @Link({ label: 'Link', description: LINK_HINT })
  href!: string;
}
